import React, { Component } from 'react'
import { MDBContainer,  MDBJumbotron,  MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon,  
    MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBDataTable, MDBInput, MDBTooltip,Button, MDBCardGroup, MDBCard,
    MDBCardBody,
    MDBCardTitle,
    MDBCardText, } from "mdbreact";
import Axios from 'axios'
import { Layout, Menu, Breadcrumb, Icon, Select, Card, Input   } from 'antd';
import { StarOutlined, StarFilled, StarTwoTone, CaretDownOutlined } from '@ant-design/icons';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import {  MDBRow, MDBCol, MDBBadge } from "mdbreact";
import Modalsentedit from './Modalsentedit';
import logosa from '../img/72734201416312710814142-512.png'


export default class Buildingreport extends Component {

    constructor(props) {
        super(props);
        this.state = {
          articlesci1:[],
          emp:[],
          term:'',
          empcouncil:[],
          classroom:[],
          building:[],
          modal: false,
          idExpert:'',
         
          idemp:'',
          citizen_id:'',
          employee_name:'',
          type:'2',
          search: '',
          research: [],
          loading:false,

          id_room:'',
          name_room:'',
          type_room:'-',
          building_name:'-',
          amount:'',



        };
        this.handleChange = this.handleChange.bind(this);

        this.onChange = this.onChange.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.getthcouncil = this.getthcouncil.bind(this);
        this.getclassroom = this.getclassroom.bind(this);
        this.updateSearch = this.updateSearch.bind(this);
        this.onTextChange = this.onTextChange.bind(this);
        this.showroom = this.showroom.bind(this);
        
      }


      componentDidMount() {
        this.setState({ loading: true})
        setTimeout(() => {
           //ภายใน
            Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getbuilding')
              // Axios.get('https://research.kpru.ac.th/Api_Research/index/research_search')
           .then(res => {
          //   console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ building: res.data})
             this.setState({ loading: false})
           }) 
         }, 0);

      }

      onTextChange = (e) => {

        this.setState({ [e.target.name]: e.target.value })
      }

      getclassroom() {

        setTimeout(() => {
           //ภายใน
            Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getclassroom')
              // Axios.get('https://research.kpru.ac.th/Api_Research/index/research_search')
           .then(res => {
           //  console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ classroom: res.data})
           
           }) 
         }, 0);

      }


      getthcouncil() {
        setTimeout(() => {
           //ภายใน
            Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getthcouncil/2/'+this.state.term)
           .then(res => {
          //   console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ empcouncil: res.data})
           }) 
         }, 0);
      }

      updateSearch(event) {
        this.setState({ search: event.target.value.substr(0, 20) });
      
    }


    updateSearchDepartment(event) {
       // console.log(event.target.value)
       const term = event.target.value;
       this.setState({ term });

       setTimeout(() => {
        this.getthcouncil()
      }, 500);
     }


     toggle = () => {
      this.setState({
        modal: !this.state.modal,
        id_room:'',
        name_room:'',
        type_room:'-',
        building_name:'-',
        amount:'',
      });
    }

    handleChange(event) {    this.setState({idExpert: event.target.value});  }

    
    onChange(value) {
        //  console.log(`selected ${value}`);




     // Axios.get('https://mua.kpru.ac.th/FrontEnd_Mis/employee/procSEmpInfo/'+value)
      //  .then(res => {
         // console.log(res.data.procSEmpInfo[0].citizen_id);
        //  this.setState({ bankname: res.data, loading: false })
       //   this.setState({ citizen_id: res.data.procSEmpInfo[0].citizen_id})
       //   this.setState({ idemp: res.data.procSEmpInfo[0].employee_id})
       //   this.setState({ employee_name: res.data.procSEmpInfo[0].employee_name})
      //  })
    
         //  const idemp = value;
         //  this.setState({ idemp });
    }
    
     onBlur() {
      console.log('blur');
    }
    
     onFocus() {
      console.log('focus');
    }
    
     onSearch(val) {
      console.log('search:', val);
    }

    handleSubmit () {
        
        const dataadd = new FormData();
        dataadd.append("id_room", this.state.id_room);
        dataadd.append("name_room", this.state.name_room);
        dataadd.append("type_room", this.state.type_room);
        dataadd.append("building_name", this.state.building_name);
        dataadd.append("amount", this.state.amount);
      
        Axios.post('https://git.kpru.ac.th/FrontEnd_Tabian/load/Addroom/',dataadd)
       
        .then(res => {
        //    console.log(res);
            if (res.status === 200) {
            //  alert("บันทึกสำเร็จ")
                      Swal.fire({
                          title: 'บันทึกข้อมูลสำเร็จ',
                          //text: 'มหาวิทยาลัยราชภัฏกำแพงเพชรขอขอบคุณ',
                          icon: 'success',
                        // showCancelButton: true,
                          confirmButtonText: 'ตกลง',
                        // cancelButtonText: 'No, keep it'
                        }).then((result) => {
                        
                        })
                     }
                })
             this.toggle()
             this.getclassroom()

      }

      showroom = (id) => { //เมื่อมีการคลิกลบ ฟังก์ชั่นนี้จะถูกเรียกใช้งาน แล้วส่ง id ที่ต้องการลบไปที่ไฟล์ delete.php
        //  console.log("dfdf")
              setTimeout(() => {
                 console.log(id)
               //  window.location.href('/Buildingreportlist/'+id);
                 window.location.href ='/tess/Buildingreportlist/'+id
               }, 1000); 

        }



    render() {
     //   console.log(this.state.classroom)
     console.log(this.state.id_room)
     console.log(this.state.name_room)
     console.log(this.state.amount)

        const { Option } = Select;
        
        let filteredPage = this.state.building.filter(
            (building) => {
              return (building.building_name.indexOf(this.state.search) !== -1) 
            }
          )

        //   const persons = !data ?  <h2>loading...</h2>:<MDBDataTable
        //     searching ={false}
        //     striped
        //     bordered
        //     hover
        //     data={data}
        //     entriesLabel="จำนวนที่แสดง "
        //     infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}

        //     responsive 
        //     />

         //ชุดตาราง
         const data = {
          columns: [
            {
              label: '#',
              field: 'list',
              sort: 'list',
              width: 150
            },
            {
              label: 'รหัสอาคาร',
              field: 'building_id',
              sort: 'building_id',
              width: 150
            },
            {
              label: 'หมายเลขอาคาร',
              field: 'building_code',
              sort: 'building_code',
              width: 270
            },
            {
              label: 'ชื่ออาคาร',
              field: 'building_name',
              sort: 'building_name',
              width: 200
            }


          ],

          rows: [...filteredPage.map((data, i) => (
            {
               list: <>{i+1}</>,
               building_id: <>{data.building_id}</>,
               building_code: <>{data.building_code}</>,
               building_name: <>{data.building_name}</>

            }
           ))]
          
      
      };

      const persons = <MDBDataTable
       searching ={false}
       searchLabel="ค้นหาชื่ออาคาร"
       striped
       bordered
       small 
       entries={20}
      // entriesOptions={["10", "20"]}
       order={["age", "desc"]}
       data={data}
       entriesLabel="จำนวนที่แสดง "
       infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
       paginationLabel={["ย้อนกลับ", "ถัดไป"]}
       responsive 
       sortRows={['random']}
       />


        return (
        <MDBContainer fluid>
          <Card type="inner"  title={<h4><MDBIcon icon="city" /> การใช้อาคารเรียน</h4>} >
            <br/>
             {/* <h5 className="text-center">ข้อมูลห้องเรียน</h5>  */}
          
          {this.state.loading === true ? <>
              <MDBRow>
                <MDBCol></MDBCol>
                <MDBCol className="text-center">
                    <div className="spinner-border text-primary" role="status">
                    <span className="sr-only text-center">Loading...</span>
                    </div>
                </MDBCol>
                <MDBCol></MDBCol>
              </MDBRow>
            
            </>: <>

            <MDBRow>
                <MDBCol size="6"> <MDBInput className="d-flex justify-content-end" label="ค้นหาชื่ออาคาร"  style={{ width: '50%' }}  onChange={this.updateSearch.bind(this)} icon="user"  /> </MDBCol>
                {/* <MDBCol size="6" className="text-right"> <MDBBtn onClick={this.toggle} color="primary" className="text-right"> <MDBIcon far icon="address-book" />  เพิ่มข้อมูล </MDBBtn></MDBCol> */}
            </MDBRow>


            {/* {persons} */}

            <MDBRow className='d-flex justify-content-center'>
           

            {/* <MDBCard>
          <MDBCardBody>
            <MDBCardTitle tag="h5">Panel title</MDBCardTitle>
            <MDBCardText>
              This is a wider panel with supporting text below as a natural
              lead-in to additional content. This content is a little bit
              longer.
            </MDBCardText>
            <MDBCardText small muted>
              Last updated 3 mins ago
            </MDBCardText>
          </MDBCardBody>
        </MDBCard> */}


            {this.state.building.map((building,index) => {
             return   <MDBCard  style={{ width: "22rem", marginTop: "1rem", marginLeft: "1.25rem" }}>
                
                <MDBCardBody>
                    {/* <MDBCardTitle tag="h5"><img src={logosa} className="rounded mx-auto " alt="aligment" width='30px' /><br/></MDBCardTitle> */}
                    <MDBCardText>
                    <p className="font-weight-bold"> {building.building_name}</p>
                 
                    {/* <img src="https://cdn.pixabay.com/photo/2016/11/29/03/56/architecture-1867194_960_720.jpg" className="img-fluid z-depth-1" alt="" /> */}
                    </MDBCardText>
                    <MDBCardText small muted>
                    <MDBBtn color="mdb-color"  onClick={() => this.showroom(building.building_id)}>แสดงข้อมูล</MDBBtn>
                    </MDBCardText>


                </MDBCardBody>
                </MDBCard>
             })}   
        
            </MDBRow>

            </> }
            {/* <p>หมายเหตุ : ข้อมูลใช้ประกอบการจัดตารางสอน ไม่ให้ชนกับการประชุม</p> */}
     
        
            </Card>
        </MDBContainer>
        
        )
    }
}
